export enum BaseSkeletonEnum {
  TABLE_VIEW = 'table-view',
  CARD_VIEW = 'card-view',
  AVATARS = 'avatars'
}
